'use client';

import { useQuery } from '@tanstack/react-query';
import { getList } from '@vimond/services/content-discovery';
import { getEnvVar } from '@vimond/utils/env';

type Props = {
  alias?: string;
  locale?: string;
};
export const useAppContent = ({
  alias = getEnvVar('NEXT_PUBLIC_CURATED_LIST_ALIAS') ?? 'vimond-via-webapp',
  locale = getEnvVar('NEXT_PUBLIC_DEFAULT_LANGUAGE') ?? 'en',
}: Props) => {
  const cacheKey = ['app', alias, locale];

  const {
    data: content,
    error,
    isLoading,
  } = useQuery({
    queryKey: cacheKey,
    queryFn: async () => {
      const result = await getList(alias, locale);
      return result;
    },
  });

  return {
    content,
    error,
    isLoading,
  };
};
